module.exports = __webpack_public_path__ + "static/media/qt.faaf71ff.png";